import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { getLang } from '../utils'

export function TagsSelector({ value, onChange, tagsType = 'uva' }) {
  const [items, setItems] = useState()

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await searchGuillotinaItem(tagsType)
    setItems(res)
  }

  if (!items) return null

  return (
    <Select
      key={tagsType}
      mode="multiple"
      style={{ width: '100%' }}
      placeholder={`Please select ${tagsType}`}
      defaultValue={value.length ? value : undefined}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={onChange}
    >
      {items.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export async function searchGuillotinaItem(tagsType) {
  const lang = getLang(new URL(window.location.href))
  const obj = await fetch(
    `/db/guillotina/@tags/${tagsType}?lang=${lang}`
  ).then((res) => res.json())
  return Object.keys(obj)
    .map((key) => ({ name: obj[key], id: key.replace(`${tagsType}/`, '') }))
    .filter((v) => v.name)
}
